export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/ArrowDiagonal.d5123b2f.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};